export const PRODOTTI_INITIAL_STATE = {
  categorie: [],
  prodotti: [],
  loading: false,
 
};
